import API from "@/models/API";
import router from "@/routes"

let storesType = () => ((router?.history.current.path||'').split('/')||[])[2] == 'storePanel' ? 'stores':'companies'
    

export default class Developers {

    static getAllEvents = () =>
    API.get(
        `/${storesType()}/${localStorage.getItem("storeId")}/events`
    );
        
    static getAllWebhooks = query =>
    API.get(
        `/${storesType()}/${localStorage.getItem("storeId")}/events/webhooks${query}`
    );
    
    static getWebhook = (id) =>
    API.get(
        `/${storesType()}/${localStorage.getItem("storeId")}/events/webhooks/${id}`
    );

    static createWebhook = (body) =>
    API.post(
        `/${storesType()}/${localStorage.getItem("storeId")}/events/webhooks`, body
    );
    
    static updateWebhook = (id, body) =>
    API.put(
        `/${storesType()}/${localStorage.getItem("storeId")}/events/webhooks/${id}`, body
    );
    
    static getWebhookLogs = (q) =>
    API.get(
        `/${storesType()}/${localStorage.getItem("storeId")}/events/webhooks/logs${q}`
    );

    static getAllResponses = () =>
    API.get(
        `/${storesType()}/${localStorage.getItem("storeId")}/events/responses`
    );

    static getEventMappers = () =>
    API.get(
        `/${storesType()}/${localStorage.getItem("storeId")}/events/response-mappers`
    );

    static getEventMapper = (id) =>
    API.get(
        `/${storesType()}/${localStorage.getItem("storeId")}/events/response-mappers/${id}`
    );

    static createEventMapper = (body) =>
    API.post(
        `/${storesType()}/${localStorage.getItem("storeId")}/events/response-mappers`, body
    );

    static updateEventMapper = (id, body) =>
    API.put(
        `/${storesType()}/${localStorage.getItem("storeId")}/events/response-mappers/${id}`, body
    );
}
